import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

let ws = null

export function initWS (accessToken) {
  if (ws) {
    return ws
  }

  console.log('initWS')
  console.log('accessToken', process.env.VUE_APP_REVERB_APP_KEY)
  ws = new Echo({
    broadcaster: 'reverb',
    authEndpoint: process.env.VUE_APP_AUTH_ENDPOINT,
    key: process.env.VUE_APP_REVERB_APP_KEY,
    wsHost: process.env.VUE_APP_REVERB_HOST,
    wsPort: process.env.VUE_APP_REVERB_PORT,
    wssPort: process.env.VUE_APP_REVERB_PORT,
    forceTLS: (process.env.VUE_APP_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
    auth: {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }
  })

  ws.connector.pusher.connection.bind('connected', () => {
    console.log('Successfully connected to Echo server.')
  })

  return ws
}
